import { createClient } from '@supabase/supabase-js'
import { mockSupabase } from './mockSupabase'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://udxbtmlncemtedzsipux.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'sb_publishable_biL0E0VdCO4dEJkqIoCIhw_ru-_XpfX'

// Check if we should use mock mode
const useMockMode = import.meta.env.VITE_USE_MOCK_SUPABASE === 'true' || 
                   supabaseUrl.includes('demo') || 
                   !supabaseUrl || 
                   !supabaseAnonKey

// Initialize Supabase client
let supabaseClient: any

if (useMockMode) {
  console.warn('🔧 Using Mock Supabase - Development Mode')
  console.warn('To use real Supabase, update your .env file with correct credentials')
  
  supabaseClient = mockSupabase
} else {
  // Validate URL format
  try {
    new URL(supabaseUrl)
    
    // Create real Supabase client
    supabaseClient = createClient(supabaseUrl, supabaseAnonKey)
    
    console.log('✅ Using Real Supabase')
  } catch (error) {
    console.error(`Invalid Supabase URL: ${supabaseUrl}. Falling back to mock mode.`)
    supabaseClient = mockSupabase
  }
}

export const supabase = supabaseClient

export type Database = {
  public: {
    Tables: {
      vehicles: {
        Row: {
          id: string
          registration_number: string
          vehicle_type: string
          brand_model: string
          seating_capacity: number
          status: 'available' | 'in_use'
          image_url: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          registration_number: string
          vehicle_type: string
          brand_model: string
          seating_capacity: number
          status?: 'available' | 'in_use'
          image_url?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          registration_number?: string
          vehicle_type?: string
          brand_model?: string
          seating_capacity?: number
          status?: 'available' | 'in_use'
          image_url?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      drivers: {
        Row: {
          id: string
          full_name: string
          phone_number: string
          status: 'available' | 'unavailable'
          line_user_id: string | null
          avatar_url: string | null
          avatar_color: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          full_name: string
          phone_number: string
          status?: 'available' | 'unavailable'
          line_user_id?: string | null
          avatar_url?: string | null
          avatar_color?: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          full_name?: string
          phone_number?: string
          status?: 'available' | 'unavailable'
          line_user_id?: string | null
          avatar_url?: string | null
          avatar_color?: string
          created_at?: string
          updated_at?: string
        }
      }
      schedule_entries: {
        Row: {
          id: string
          usage_date: string | null // Keep for backward compatibility
          start_date: string
          end_date: string
          is_range: boolean
          start_time: string
          end_time: string
          vehicle_id: string
          driver_id: string
          notes: string | null
          time_slot: string | null
          locations: any[] | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          usage_date?: string | null // Keep for backward compatibility
          start_date: string
          end_date: string
          is_range?: boolean
          start_time: string
          end_time: string
          vehicle_id: string
          driver_id: string
          notes?: string | null
          time_slot?: string | null
          locations?: any[] | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          usage_date?: string | null // Keep for backward compatibility
          start_date?: string
          end_date?: string
          is_range?: boolean
          start_time?: string
          end_time?: string
          vehicle_id?: string
          driver_id?: string
          notes?: string | null
          time_slot?: string | null
          locations?: any[] | null
          created_at?: string
          updated_at?: string
        }
      }
      settings: {
        Row: {
          id: string
          key: string
          value: any
          description: string | null
          category: string
          is_encrypted: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          key: string
          value?: any
          description?: string | null
          category?: string
          is_encrypted?: boolean
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          key?: string
          value?: any
          description?: string | null
          category?: string
          is_encrypted?: boolean
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
